import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { MovePlaylistDocument } from './move.generated';

export const useMovePlaylist = (options: ApiOptions<typeof MovePlaylistDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(MovePlaylistDocument, {
    ...useNotifications(MovePlaylistDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.playlists.move_success'),
    }),
    ...options,
  });
};
